// extracted by mini-css-extract-plugin
export default {"shubhYatra_wrapper_bus":"buses_shubhYatra_wrapper_bus__oMdWI"};